import React from 'react';
import { useTranslations } from '../../locales/useTranslations';
import { BiServer, BiShield, BiHeadphone } from 'react-icons/bi';

const ManagedServicesOverview = () => {
  const { t } = useTranslations();
  const pillars = [
    {
      icon: BiServer,
      title: t('managedServices_pillar1_title'),
      desc: t('managedServices_pillar1_desc'),
    },
    {
      icon: BiShield,
      title: t('managedServices_pillar2_title'),
      desc: t('managedServices_pillar2_desc'),
    },
    {
      icon: BiHeadphone,
      title: t('managedServices_pillar3_title'),
      desc: t('managedServices_pillar3_desc'),
    },
  ];

  return (
    <section className="ms-section ms-section--overview">
      <div className="container">
        <div className="ms-section-header ms-section-header--center">
          <span className="ms-section__badge">{t('managedServices_overview_badge')}</span>
          <h2 className="ms-section__title">{t('managedServices_overview_title')}</h2>
          <p className="ms-section__lead ms-section__lead--center">
            {t('managedServices_overview_description')}
          </p>
        </div>
        <div className="row">
          {pillars.map((pillar, index) => {
            const Icon = pillar.icon;
            return (
              <div key={index} className="col-lg-4 col-md-6 mb-4">
                <div className="ms-pillar ms-pillar--enhanced">
                  <div className="ms-pillar__icon">
                    <Icon aria-hidden />
                  </div>
                  <h3 className="ms-pillar__title">{pillar.title}</h3>
                  <p className="ms-pillar__desc">{pillar.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ManagedServicesOverview;
